export const translations = {
    en: {
        home: "Home",
        vip: "VIP",
        promotion: "Promotion",
        promotions: "Promotions",
        freePromo: "Free Promo",
        affiliate: "Affiliate",
        myAccount: "My Account",
        aboutUs: "About Us",
        contactUs: "Contact Us",
        liveMatch: "Live Match",
        rewards: "Rewards",
        termsConditions: "Terms & Conditions",
        regionLanguage: "Region Language",
        english: "English",
        bangla: "Bangla",
        login: "Log in",
        profile: "Profile",
        menu: "Menu",
        casino: "Casino",
        slots: "Slots",
        sport: "Sport",
        aviator: "Aviator",
        jetx: "JetX",
        betgames: "Betgames",
        tournaments: "Tournaments",
        liveCasino: "LIVE Casino",
        instant: "Instant",
        lottery: "Lottery",
        table: "Table",
        virtuals: "Virtuals",
        search: "Search",
        noGamesFound: "No games found.",
        loadMore: "Load more",
        languageEnglish: "English",
        languageBangla: "Bangla",
        footerAboutTitle: ({ brandName }) => `About Us — ${brandName}`,
        footerAboutPara1: ({ brandName }) =>
            `${brandName} is one of Bangladesh’s most advanced and world-class online gaming and sports exchange platforms. We are committed to providing players with a safe, fast, and seamless online betting experience. From sports betting, cricket exchange, live casino, slots, and arcade games—you’ll find a wide range of exciting options, all fully mobile-friendly and accessible 24/7.`,
        footerAboutPara2: ({ brandName }) =>
            `${brandName} was established with a clear mission—to create a trusted, transparent, and internationally standard gaming experience for players in Bangladesh. Ensuring user security, privacy, and fast payment processing is our top priority.`,
        footerWhatMakesUsSpecial: "What Makes Us Special",
        footerFastDepositTitle: "⭐ Fast Deposit & Instant Withdrawal",
        footerFastDepositDesc:
            "We provide one of the quickest and most secure payment systems in Bangladesh—allowing deposits and withdrawals to be completed within minutes.",
        footerSupportTitle: "⭐ 24/7 Live Support",
        footerSupportDesc:
            "Our professional support team is always available to assist you with any questions or issues. We aim to ensure the best user experience at all times.",
        footerSafeTitle: "⭐ Safe & Trusted Platform",
        footerSafeDesc:
            "We use advanced data security systems, SSL encryption, and robust servers to guarantee maximum protection of your account and financial transactions.",
        footerGamesTitle: "⭐ Extensive Game Collection",
        footerGamesDesc:
            "From live dealer casino games to cricket betting, football, slots, Aviator, Mines, and many more—all available under one single platform.",
        footerBonusTitle: "⭐ Attractive Bonuses & Promotions",
        footerBonusDesc:
            "Both new and existing users enjoy regular bonuses, cashback, free spins, and exclusive VIP rewards.",
        footerVisionTitle: "Our Vision",
        footerVisionDesc:
            "To modernize and elevate the online gaming industry in Bangladesh by promoting a safe, responsible, and world-class gaming culture.",
        footerMissionTitle: "Our Mission",
        footerMission1: "Deliver the fastest payment and support experience",
        footerMission2: "Build the most secure gaming platform",
        footerMission3: "Continuously add new games and features based on player interest",
        footerMission4: "Ensure a transparent and responsible betting environment",
        footerWhyChooseTitle: ({ brandName }) => `Why Choose ${brandName}?`,
        footerWhy1: "100% Bangladesh-friendly",
        footerWhy2: "Smooth gameplay on both mobile & PC",
        footerWhy3: "VIP program and daily bonuses",
        footerWhy4: "Trusted and responsive support",
        footerWhy5: "Safe, transparent, and reliable service",
        footerTrustedPartner: ({ brandName }) =>
            `${brandName} – Your Trusted Gaming Partner in Bangladesh`,
        footerTrustLine: "We believe your trust is our greatest strength.",
        footerClosingLine: ({ brandName }) =>
            `With ${brandName}, gaming becomes faster, easier, safer, and more thrilling.`,
        readMore: "Read More",
        readLess: "Read Less",
        paymentMethods: "Payment Methods",
        followUs: "Follow Us",
        certifications: "Certifications",
        communityWebsite: "Community Website",
        gamingLicense: "Gaming License",
        register: "Register",
        totalBalance: "Total Balance",
        refreshBalance: "Refresh balance",
        deposit: "Deposit",
        withdrawal: "Withdrawal",
        memberProfile: "Member Profile",
        tell: "TELL",
        basicInformation: "Basic Information",
        changePassword: "Change Password",
        rebateReport: "Rebate Report",
        promoFreeList: "Promo Free List",
        vipBonusReport: "VIP Bonus Report",
        transfer: "Transfer",
        betReports: "Bet Reports",
        statements: "Statements",
        notice: "Notice",
        referralProgram: "Referral Program",
        turnoverChecking: "Turnover Checking",
        signIn: "Sign In",
        logout: "Logout",
        all: "All",
        sports: "Sports",
        casino: "Casino",
        promotion: "Promotion",
        pleaseCompleteTurnover: "Please complete your turnover and try again.",
        anErrorOccurred: "An error occurred.",
        anUnknownErrorOccurred: "An unknown error occurred.",
        eligibilityCheckFailed: "Eligibility check failed. Please try again.",
        pleaseSelectBank: "Please select a bank.",
        accountNameRequired: "Account name is required.",
        bankNumberRequired: "Bank number is required.",
        amountRequired: "Amount is required.",
        failedToSubmitWithdrawal: "Failed to submit withdrawal.",
        withdrawalSuccessful: "Withdrawal successful!",
        somethingWentWrong: "Something went wrong.",
        anErrorOccurredPleaseTryAgain: "An error occurred. Please try again.",
        pleaseBindBankAccountBeforeWithdrawMoney: "Please Bind Bank Account Before Withdraw Money",
        bank: "Bank",
        selectBank: "Select bank",
        accountName: "Account Name",
        enterAccountName: "Enter account name",
        bankNo: "Bank NO",
        enterBankNumber: "Enter bank number",
        amount: "Amount",
        submitting: "Submitting...",
        submit: "Submit",
        ok: "OK",
        participateInPromotion: "Participate In Promotion",
        pleaseFillAmount: "Please fill in your amount.",
        amountMustBeBetween: ({ currency, min, max }) =>
            `Amount must be between ${currency}${min} and ${currency}${max}.`,
        pleaseSelectValidPaymentMethod: "Please select a valid payment method.",
        pleaseSelectDepositChannel: "Please select a Deposit channel.",
        unableToStartPayment: "Unable to start payment. Please try again.",
        depositList: "Deposit List",
        mainBalanceBdt: "Main Balance (BDT)",
        freeEventWalletBdt: "Free Event Wallet (BDT)",
        selectChannel: "Select Channel",
        loadingChannels: "Loading channels...",
        channel: "Channel",
        no: "No",
        type: "Type",
        time: "Time",
        status: "Status",
        receipt: "Receipt",
        noRecordFound: "No record found!",
        selectAPromotion: "Select A Promotion",
        viewPromotionDetails: "View promotion details",
        confirm: "Confirm",
        vipBonus: "VIP Bonus",
        currentStatus: "Current Status:",
        previousLevel: "Previous level",
        nextLevel: "Next level",
        depositRequirement: "Deposit Requirement",
        turnoverRequirement: "Turnover Requirement",
        vipPrivileges: "VIP PRIVILEGES",
        faqs: "FAQs",
        onwards: "Onwards",
        other: "Other",
        freeEvent: "Free Event",
        vipNormal: "NORMAL",
        vipBronze: "BRONZE",
        vipSilver: "SILVER",
        vipGold: "GOLD",
        vipPlatinum: "PLATINUM",
        vipDiamond: "DIAMOND",

        vip60DaysTurnover: "60 Days Of Turnover To Maintain VIP Level",
        totalDeposit: "Total Deposit",
        upgradeBonus: "Upgrade Bonus",
        upgradeBonusRate: "Upgrade Bonus Rate",
        weeklyBonus: "Weekly Bonus",
        weeklyBonusTurnover: "Weekly Bonus Turnover",
        dailyTurnoverRatio: "Daily Turnover Ratio",
        dailyTurnoverRate: "Daily Turnover Rate",
        birthdayBonus: "Birthday Bonus",
        birthdayBonusTurnoverRate: "Birthday Bonus Turnover Rate",

        vipTerms1: "VIP benefits are based on your level and platform rules.",
        vipTerms2: ({ brandName }) =>
            `${brandName} may update VIP rules, rewards, or conditions without prior notice.`,
        vipTerms3:
            "Any abuse, fraud, or bonus manipulation may cancel VIP privileges.",

        vipFaq1Q: "How do I upgrade my VIP level?",
        vipFaq1A:
            "Your VIP level upgrades based on total deposit and turnover requirements.",
        vipFaq2Q: "How is weekly bonus calculated?",
        vipFaq2A:
            "Weekly bonus depends on your VIP tier and eligible turnover completed during the week.",
        UpdateProfile:"Update Profile",
    },

    bn: {
          UpdateProfile:"প্রোফাইল আপডেট করুন",
        home: "হোম",
        vip: "ভিআইপি",
        promotion: "প্রোমোশন",
        promotions: "প্রোমোশনসমূহ",
        freePromo: "ফ্রি প্রোমো",
        affiliate: "অ্যাফিলিয়েট",
        myAccount: "আমার অ্যাকাউন্ট",
        aboutUs: "আমাদের সম্পর্কে",
        contactUs: "যোগাযোগ করুন",
        liveMatch: "লাইভ ম্যাচ",
        rewards: "রিওয়ার্ডস",
        termsConditions: "শর্তাবলী",
        regionLanguage: "ভাষা নির্বাচন",
        english: "ইংরেজি",
        bangla: "বাংলা",
        login: "লগ ইন",
        profile: "প্রোফাইল",
        menu: "মেনু",
        casino: "ক্যাসিনো",
        slots: "স্লটস",
        sport: "স্পোর্ট",
        aviator: "এভিয়েটর",
        jetx: "জেটএক্স",
        betgames: "বেটগেমস",
        tournaments: "টুর্নামেন্ট",
        liveCasino: "লাইভ ক্যাসিনো",
        instant: "ইনস্ট্যান্ট",
        lottery: "লটারি",
        table: "টেবিল",
        virtuals: "ভার্চুয়ালস",
        search: "সার্চ",
        noGamesFound: "কোনো গেম পাওয়া যায়নি।",
        loadMore: "আরও দেখুন",
        languageEnglish: "English",
        languageBangla: "বাংলা",
        footerAboutTitle: ({ brandName }) => `আমাদের সম্পর্কে — ${brandName}`,
        footerAboutPara1: ({ brandName }) =>
            `${brandName} বাংলাদেশের অন্যতম আধুনিক ও বিশ্বমানের অনলাইন গেমিং এবং স্পোর্টস এক্সচেঞ্জ প্ল্যাটফর্ম। আমরা খেলোয়াড়দের জন্য নিরাপদ, দ্রুত এবং ঝামেলাহীন অনলাইন বেটিং অভিজ্ঞতা দিতে প্রতিশ্রুতিবদ্ধ। স্পোর্টস বেটিং, ক্রিকেট এক্সচেঞ্জ, লাইভ ক্যাসিনো, স্লটস এবং আর্কেড গেমস—সবকিছুই এখানে মোবাইল-ফ্রেন্ডলি ও ২৪/৭ অ্যাক্সেসযোগ্য।`,
        footerAboutPara2: ({ brandName }) =>
            `${brandName} একটি পরিষ্কার লক্ষ্য নিয়ে প্রতিষ্ঠিত হয়েছে—বাংলাদেশের খেলোয়াড়দের জন্য একটি বিশ্বমানের, স্বচ্ছ এবং নির্ভরযোগ্য গেমিং অভিজ্ঞতা তৈরি করা। ব্যবহারকারীর নিরাপত্তা, গোপনীয়তা এবং দ্রুত পেমেন্ট প্রসেসিং আমাদের সর্বোচ্চ অগ্রাধিকার।`,
        footerWhatMakesUsSpecial: "কী আমাদের আলাদা করে",
        footerFastDepositTitle: "⭐ দ্রুত ডিপোজিট ও তাৎক্ষণিক উইথড্র",
        footerFastDepositDesc:
            "আমরা বাংলাদেশের অন্যতম দ্রুত ও নিরাপদ পেমেন্ট সিস্টেম প্রদান করি—যেখানে ডিপোজিট ও উইথড্র কয়েক মিনিটেই সম্পন্ন হয়।",
        footerSupportTitle: "⭐ ২৪/৭ লাইভ সাপোর্ট",
        footerSupportDesc:
            "আমাদের পেশাদার সাপোর্ট টিম সবসময় আপনার যেকোনো প্রশ্ন বা সমস্যায় সহায়তা করতে প্রস্তুত। আমরা সর্বদা সেরা ব্যবহারকারী অভিজ্ঞতা নিশ্চিত করতে চাই।",
        footerSafeTitle: "⭐ নিরাপদ ও বিশ্বস্ত প্ল্যাটফর্ম",
        footerSafeDesc:
            "আমরা উন্নত ডাটা সিকিউরিটি, SSL এনক্রিপশন এবং শক্তিশালী সার্ভার ব্যবহার করি যাতে আপনার অ্যাকাউন্ট ও আর্থিক লেনদেন সর্বোচ্চ সুরক্ষিত থাকে।",
        footerGamesTitle: "⭐ বিশাল গেম কালেকশন",
        footerGamesDesc:
            "লাইভ ডিলার ক্যাসিনো থেকে ক্রিকেট বেটিং, ফুটবল, স্লটস, Aviator, Mines এবং আরও অনেক কিছু—সব এক প্ল্যাটফর্মে।",
        footerBonusTitle: "⭐ আকর্ষণীয় বোনাস ও প্রোমোশন",
        footerBonusDesc:
            "নতুন এবং পুরোনো উভয় ব্যবহারকারীই নিয়মিত বোনাস, ক্যাশব্যাক, ফ্রি স্পিন এবং এক্সক্লুসিভ VIP রিওয়ার্ড উপভোগ করেন।",
        footerVisionTitle: "আমাদের ভিশন",
        footerVisionDesc:
            "নিরাপদ, দায়িত্বশীল এবং বিশ্বমানের গেমিং সংস্কৃতি গড়ে তুলে বাংলাদেশের অনলাইন গেমিং ইন্ডাস্ট্রিকে আধুনিক ও উন্নত করা।",
        footerMissionTitle: "আমাদের মিশন",
        footerMission1: "সবচেয়ে দ্রুত পেমেন্ট ও সাপোর্ট অভিজ্ঞতা প্রদান করা",
        footerMission2: "সবচেয়ে নিরাপদ গেমিং প্ল্যাটফর্ম তৈরি করা",
        footerMission3: "খেলোয়াড়দের আগ্রহ অনুযায়ী নিয়মিত নতুন গেম ও ফিচার যোগ করা",
        footerMission4: "স্বচ্ছ ও দায়িত্বশীল বেটিং পরিবেশ নিশ্চিত করা",
        footerWhyChooseTitle: ({ brandName }) => `কেন ${brandName} বেছে নেবেন?`,
        footerWhy1: "১০০% বাংলাদেশ-ফ্রেন্ডলি",
        footerWhy2: "মোবাইল ও পিসি—উভয় ডিভাইসে স্মুথ গেমপ্লে",
        footerWhy3: "VIP প্রোগ্রাম ও দৈনিক বোনাস",
        footerWhy4: "বিশ্বস্ত ও দ্রুত সাপোর্ট",
        footerWhy5: "নিরাপদ, স্বচ্ছ ও নির্ভরযোগ্য সেবা",
        footerTrustedPartner: ({ brandName }) =>
            `${brandName} – বাংলাদেশের বিশ্বস্ত গেমিং পার্টনার`,
        footerTrustLine: "আমরা বিশ্বাস করি আপনার আস্থাই আমাদের সবচেয়ে বড় শক্তি।",
        footerClosingLine: ({ brandName }) =>
            `${brandName}-এর সাথে গেমিং হয় আরও দ্রুত, সহজ, নিরাপদ এবং রোমাঞ্চকর।`,
        readMore: "আরও দেখুন",
        readLess: "কম দেখুন",
        paymentMethods: "পেমেন্ট মেথড",
        followUs: "আমাদের অনুসরণ করুন",
        certifications: "সার্টিফিকেশন",
        communityWebsite: "কমিউনিটি ওয়েবসাইট",
        gamingLicense: "গেমিং লাইসেন্স",
        register: "রেজিস্টার",
        totalBalance: "মোট ব্যালেন্স",
        refreshBalance: "ব্যালেন্স রিফ্রেশ করুন",
        deposit: "ডিপোজিট",
        withdrawal: "উইথড্র",
        memberProfile: "মেম্বার প্রোফাইল",
        tell: "ফোন",
        basicInformation: "মৌলিক তথ্য",
        changePassword: "পাসওয়ার্ড পরিবর্তন",
        rebateReport: "রিবেট রিপোর্ট",
        promoFreeList: "ফ্রি প্রোমো তালিকা",
        vipBonusReport: "VIP বোনাস রিপোর্ট",
        transfer: "ট্রান্সফার",
        betReports: "বেট রিপোর্ট",
        statements: "স্টেটমেন্ট",
        notice: "নোটিশ",
        referralProgram: "রেফারেল প্রোগ্রাম",
        turnoverChecking: "টার্নওভার চেকিং",
        signIn: "সাইন ইন",
        logout: "লগ আউট",
        all: "সব",
        sports: "স্পোর্টস",
        casino: "ক্যাসিনো",
        promotion: "প্রোমোশন",
        pleaseCompleteTurnover: "অনুগ্রহ করে আপনার টার্নওভার সম্পূর্ণ করে আবার চেষ্টা করুন।",
        anErrorOccurred: "একটি সমস্যা হয়েছে।",
        anUnknownErrorOccurred: "একটি অজানা সমস্যা হয়েছে।",
        eligibilityCheckFailed: "যাচাই ব্যর্থ হয়েছে। আবার চেষ্টা করুন।",
        pleaseSelectBank: "অনুগ্রহ করে একটি ব্যাংক নির্বাচন করুন।",
        accountNameRequired: "অ্যাকাউন্টের নাম প্রয়োজন।",
        bankNumberRequired: "ব্যাংক নম্বর প্রয়োজন।",
        amountRequired: "পরিমাণ প্রয়োজন।",
        failedToSubmitWithdrawal: "উইথড্র জমা দিতে ব্যর্থ হয়েছে।",
        withdrawalSuccessful: "উইথড্র সফল হয়েছে!",
        somethingWentWrong: "কিছু সমস্যা হয়েছে।",
        anErrorOccurredPleaseTryAgain: "একটি সমস্যা হয়েছে। আবার চেষ্টা করুন।",
        pleaseBindBankAccountBeforeWithdrawMoney: "উইথড্র করার আগে অনুগ্রহ করে ব্যাংক অ্যাকাউন্ট সংযুক্ত করুন",
        bank: "ব্যাংক",
        selectBank: "ব্যাংক নির্বাচন করুন",
        accountName: "অ্যাকাউন্ট নাম",
        enterAccountName: "অ্যাকাউন্ট নাম লিখুন",
        bankNo: "ব্যাংক নম্বর",
        enterBankNumber: "ব্যাংক নম্বর লিখুন",
        amount: "পরিমাণ",
        submitting: "জমা দেওয়া হচ্ছে...",
        submit: "জমা দিন",
        ok: "ঠিক আছে",
        participateInPromotion: "প্রোমোশনে অংশগ্রহণ করুন",
        pleaseFillAmount: "অনুগ্রহ করে পরিমাণ লিখুন।",
        amountMustBeBetween: ({ currency, min, max }) =>
            `পরিমাণ ${currency}${min} এবং ${currency}${max} এর মধ্যে হতে হবে।`,
        pleaseSelectValidPaymentMethod: "অনুগ্রহ করে একটি সঠিক পেমেন্ট মেথড নির্বাচন করুন।",
        pleaseSelectDepositChannel: "অনুগ্রহ করে একটি ডিপোজিট চ্যানেল নির্বাচন করুন।",
        unableToStartPayment: "পেমেন্ট শুরু করা যায়নি। আবার চেষ্টা করুন।",
        depositList: "ডিপোজিট তালিকা",
        mainBalanceBdt: "মেইন ব্যালেন্স (BDT)",
        freeEventWalletBdt: "ফ্রি ইভেন্ট ওয়ালেট (BDT)",
        selectChannel: "চ্যানেল নির্বাচন করুন",
        loadingChannels: "চ্যানেল লোড হচ্ছে...",
        channel: "চ্যানেল",
        freeEvent: "বিনামূল্যে ইভেন্ট",
        no: "নং",
        type: "ধরণ",
        time: "সময়",
        status: "স্ট্যাটাস",
        receipt: "রসিদ",
        noRecordFound: "কোনো রেকর্ড পাওয়া যায়নি!",
        selectAPromotion: "একটি প্রোমোশন নির্বাচন করুন",
        viewPromotionDetails: "প্রোমোশনের বিস্তারিত দেখুন",
        confirm: "নিশ্চিত করুন",
        vipBonus: "ভিআইপি বোনাস",
        currentStatus: "বর্তমান স্ট্যাটাস:",
        previousLevel: "পূর্বের লেভেল",
        nextLevel: "পরের লেভেল",
        depositRequirement: "ডিপোজিটের শর্ত",
        turnoverRequirement: "টার্নওভারের শর্ত",
        vipPrivileges: "ভিআইপি সুবিধাসমূহ",
        faqs: "সাধারণ প্রশ্ন",
        onwards: "থেকে শুরু",
        other: "অন্যান্য",

        vipNormal: "নরমাল",
        vipBronze: "ব্রোঞ্জ",
        vipSilver: "সিলভার",
        vipGold: "গোল্ড",
        vipPlatinum: "প্লাটিনাম",
        vipDiamond: "ডায়মন্ড",

        vip60DaysTurnover: "ভিআইপি লেভেল ধরে রাখতে ৬০ দিনের টার্নওভার",
        totalDeposit: "মোট ডিপোজিট",
        upgradeBonus: "আপগ্রেড বোনাস",
        upgradeBonusRate: "আপগ্রেড বোনাস রেট",
        weeklyBonus: "সাপ্তাহিক বোনাস",
        weeklyBonusTurnover: "সাপ্তাহিক বোনাস টার্নওভার",
        dailyTurnoverRatio: "দৈনিক টার্নওভার অনুপাত",
        dailyTurnoverRate: "দৈনিক টার্নওভার রেট",
        birthdayBonus: "জন্মদিন বোনাস",
        birthdayBonusTurnoverRate: "জন্মদিন বোনাস টার্নওভার রেট",

        vipTerms1: "ভিআইপি সুবিধা আপনার লেভেল এবং প্ল্যাটফর্মের নিয়ম অনুযায়ী নির্ধারিত হয়।",
        vipTerms2: ({ brandName }) =>
            `${brandName} পূর্ব নোটিশ ছাড়াই ভিআইপি নিয়ম, রিওয়ার্ড বা শর্ত পরিবর্তন করতে পারে।`,
        vipTerms3:
            "কোনো অপব্যবহার, জালিয়াতি বা বোনাস অপব্যবহার হলে ভিআইপি সুবিধা বাতিল হতে পারে।",

        vipFaq1Q: "আমি কীভাবে আমার ভিআইপি লেভেল আপগ্রেড করব?",
        vipFaq1A:
            "মোট ডিপোজিট এবং টার্নওভার শর্ত পূরণ করলে আপনার ভিআইপি লেভেল আপগ্রেড হবে।",
        vipFaq2Q: "সাপ্তাহিক বোনাস কীভাবে গণনা করা হয়?",
        vipFaq2A:
            "সাপ্তাহিক বোনাস আপনার ভিআইপি স্তর এবং সপ্তাহে সম্পন্ন হওয়া যোগ্য টার্নওভারের ওপর নির্ভর করে।",
    },

};